import React from 'react'
import { Box, Stack, Typography, Alert } from '@mui/material'
import { useSuspenseQuery } from '@tanstack/react-query'
import { AccountBalanceWalletOutlined } from '@mui/icons-material'

import { createPaymentCreditsQueryOptions } from '@/api/payment/queries'
import { numericUtils } from '@/utils/numeric'

export const WalletTabHeader: React.FC = () => {
  const { data: credits } = useSuspenseQuery(createPaymentCreditsQueryOptions())
  const isNegativeBalance = Number(credits?.balance || 0) < 0

  return (
    <Stack direction="column" width="100%" spacing={2}>
      <Box
        sx={{
          p: 2,
          borderRadius: 3,
          backgroundColor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" spacing={1}>
            <AccountBalanceWalletOutlined sx={{ fontSize: 20 }} color="action" />
            <Typography variant="subtitle2" fontWeight="semibold" color="text.secondary">
              Saldo atual:
            </Typography>
          </Stack>
          <Typography
            variant="h6"
            fontSize={16}
            fontWeight="bold"
            color={isNegativeBalance ? 'error.main' : 'primary.main'}
          >
            {numericUtils.formatNumberToBRLCurrency(Number(credits?.balance || 0))}
          </Typography>
        </Stack>
      </Box>
      <Alert severity="warning" sx={{ borderRadius: 2 }}>
        Novos pagamentos serão realizados ao iniciar uma sessão de carregamento.
      </Alert>
    </Stack>
  )
}
